(function(){
  var SCHWELLE = 5900, MENGE_ZIEL = 3;
  var letzterStand = null, timer = null, beobachter = null;

  function euro(cent){ return (cent/100).toFixed(2).replace(".", ",") + " €"; }

  // Preis der gerade gewaehlten Variante auf der Produktseite, in Cent.
  // Quelle ist die Sticky-Leiste bzw. der Preisblock, beide zeigen "€91,90".
  function pdpPreis(){
    var p = document.querySelector(".fl-stickybar__price") || document.querySelector(".fl-buy__price");
    if(!p) return 0;
    var m = (p.textContent || "").replace(/\./g, "").match(/(\d+),(\d{2})/);
    return m ? parseInt(m[1], 10) * 100 + parseInt(m[2], 10) : 0;
  }

  function baue(el, stand){
    if(!el) return;
    var total = stand.total, menge = stand.menge, pflanzen = stand.pflanzen;
    var fehlt = MENGE_ZIEL - pflanzen;
    var rabattDa = pflanzen >= MENGE_ZIEL;
    var versandDa = total >= SCHWELLE || menge >= MENGE_ZIEL;
    var anteil = Math.max(0, Math.min(100, Math.round(
      Math.max(total / SCHWELLE, menge / MENGE_ZIEL) * 100)));

    // Ab 59 Euro ist schon diese eine Pflanze versandkostenfrei. Die
    // Drei-Pflanzen-Aktion waere hier die falsche Botschaft.
    var istPdp = el.className.indexOf("fl-ship--pdp") !== -1;
    var pdpFrei = istPdp && !rabattDa && pdpPreis() >= SCHWELLE;

    var text;
    if(pdpFrei){
      text = "Diese Pflanze kommt <b>versandkostenfrei</b> zu dir";
      anteil = 100;
    } else if(rabattDa){
      text = "<b>10 % Rabatt</b> und Gratisversand erreicht";
    } else if(versandDa){
      text = fehlt > 0
        ? "Gratisversand erreicht. Noch <b>" + fehlt + (fehlt === 1 ? " Pflanze" : " Pflanzen") + "</b> für 10 % Rabatt"
        : "Gratisversand erreicht";
    } else if(fehlt === 1){
      text = "Noch <b>1 Pflanze</b>: 10 % Rabatt und Versand frei";
    } else if(fehlt === 2){
      text = "Noch <b>2 Pflanzen</b>: 10 % Rabatt und Versand frei";
    } else {
      text = "<b>3 Pflanzen</b>: 10 % Rabatt und Versand frei";
    }

    var neu = '<div class="fl-ship__row"><span class="fl-ship__txt">' + text
      + '</span></div><div class="fl-ship__bar"><span style="width:' + anteil + '%"></span></div>';
    if(el.innerHTML !== neu) el.innerHTML = neu;
    el.setAttribute("data-erreicht", (rabattDa || pdpFrei) ? "ja" : "nein");
  }

  // Sticky-Leiste unten auf dem Handy: dort stehen Preis und Knopf im ersten
  // Bildschirm. Ab 59 Euro kommt "versandkostenfrei" direkt unter den Preis.
  function stickyHinweis(){
    var info = document.querySelector(".fl-stickybar__info");
    if(!info) return;
    var vorhanden = info.querySelector(".fl-stickybar__frei");
    if(pdpPreis() >= SCHWELLE){
      if(!vorhanden){
        var s = document.createElement("span");
        s.className = "fl-stickybar__frei";
        s.textContent = "versandkostenfrei";
        info.appendChild(s);
      }
    } else if(vorhanden){
      vorhanden.parentNode.removeChild(vorhanden);
    }
  }

  function hole(klasse, anker, position){
    if(!anker) return null;
    var vorhanden = document.querySelector("." + klasse.split(" ").join("."));
    if(vorhanden) return vorhanden;
    var el = document.createElement("div");
    el.className = klasse;
    if(position === "danach") anker.parentNode.insertBefore(el, anker.nextSibling);
    else if(position === "vorher") anker.parentNode.insertBefore(el, anker);
    else anker.insertBefore(el, anker.firstChild);
    return el;
  }

  function ziele(){
    var liste = [];

    var rewards = document.querySelector(".fl-cd__rewards");
    var drawerFoot = document.querySelector(".fl-cd__foot");
    var d = rewards ? hole("fl-ship fl-ship--drawer", rewards, "danach")
                    : hole("fl-ship fl-ship--drawer", drawerFoot, "davor");
    if(d) liste.push(d);

    // Auf der Produktseite steht die Aktion ueber der Kaufzeile, nicht darunter:
    // dort wird sie gelesen, bevor der Knopf gedrueckt wird.
    var buyBox = document.querySelector(".fl-buy__cart");
    if(buyBox) liste.push(hole("fl-ship fl-ship--pdp", buyBox, "vorher"));

    var cartRw = document.querySelector(".fl-cp-rw");
    var cartRows = document.querySelector(".fl-cp-sum__rows");
    var c = cartRw ? hole("fl-ship fl-ship--cart", cartRw, "danach")
                   : hole("fl-ship fl-ship--cart", cartRows, "davor");
    if(c) liste.push(c);

    return liste.filter(Boolean);
  }

  function zeichne(stand){
    ziele().forEach(function(el){ baue(el, stand); });
    stickyHinweis();
  }

  // Die 10 Prozent gelten fuer die Collection "Pflanzen (Aktion)":
  // Typ Plant ohne den Tag rabatt-xl-aus. Sets tragen den Typ Set und zaehlen
  // ohnehin nicht. Diese elf Produkte laufen als Plant, sind aber Mehrstueck-Sets
  // und deshalb ausgenommen; der Warenkorb liefert kein Tag-Feld, daher die Liste.
  var SETS_ALS_PFLANZE = {
    11983857942868: 1, 11983858008404: 1, 11983858106708: 1, 11983858401620: 1,
    11983857975636: 1, 11984233267540: 1, 11984233922900: 1, 11984231891284: 1,
    15481101189460: 1, 15481101222228: 1, 15481105678676: 1
  };

  function lies(cart){
    var menge = 0, pflanzen = 0;
    var items = (cart && cart.items) || [];
    for(var i = 0; i < items.length; i++){
      var anzahl = items[i].quantity || 0;
      menge += anzahl;
      if(items[i].product_type === "Plant" && !SETS_ALS_PFLANZE[items[i].product_id]) pflanzen += anzahl;
    }
    return {
      total: (cart && typeof cart.total_price === "number") ? cart.total_price : 0,
      menge: menge,
      pflanzen: pflanzen
    };
  }

  function aktualisiere(){
    fetch("/cart.js", { credentials: "same-origin" })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        letzterStand = lies(cart);
        zeichne(letzterStand);
      })
      .catch(function(){});
  }

  function spaeter(){
    clearTimeout(timer);
    timer = setTimeout(aktualisiere, 700);
  }

  function starteBeobachter(){
    if(beobachter || !window.MutationObserver) return;
    beobachter = new MutationObserver(function(){
      if(letzterStand === null) return;
      var fehltZiel = (document.querySelector(".fl-cd__rewards") || document.querySelector(".fl-cd__foot")) && !document.querySelector(".fl-ship--drawer");
      var fehltCart = (document.querySelector(".fl-cp-rw") || document.querySelector(".fl-cp-sum__rows")) && !document.querySelector(".fl-ship--cart");
      var info = document.querySelector(".fl-stickybar__info");
      var fehltSticky = info && pdpPreis() >= SCHWELLE && !info.querySelector(".fl-stickybar__frei");
      if(fehltZiel || fehltCart || fehltSticky) zeichne(letzterStand);
    });
    beobachter.observe(document.body, { childList: true, subtree: true });
  }

  function start(){ starteBeobachter(); aktualisiere(); }

  if(document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();

  document.addEventListener("click", function(e){
    var t = e.target;
    if(!t || !t.closest) return;
    if(t.closest(".fl-buy__cart, .fl-btn, .fl-card__quickadd, .fl-qty button, .fl-pot__btn, .fl-cd-item__row button, .fl-cd-item__rm, .fl-cd-card__add, .fl-cp-item__row button, .fl-cp-item__rm, .fl-cp-card__add, [data-cart-open], .fl-cart-count, .fl-buy__opt-btn")) spaeter();
  }, true);

  window.addEventListener("pageshow", aktualisiere);
})();
